import { useEffect, useRef, useState } from 'react';
import { Jisa } from 'type/type';
import { getJisaAll } from 'api/api';
import Pagenation from 'components/common/Pagenation';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CommonTable, CommonTableWrap, FilterContentContainer } from 'pages/Layout';
import { PrimaryButton } from 'components/common/Button';
import { formattedDateTime } from 'pages/utils/commonUtils';

interface SearchInputType {
  type: string,
  value: string,
  page?: number,
};

function JisaList() {
  const isFirstRender = useRef(true);
  const [searchParams, setSearchParams] = useSearchParams();
  // 필터obj
  const [searchObj, setSearchObj] = useState<SearchInputType>({
    type: searchParams.get("type") || "bonbu_name",
    value: searchParams.get("value") || "",
    page: searchParams.get("page") ? Number(searchParams.get("page")) : undefined,
  });
  const navigate = useNavigate();
  const [jisaArr, setJisaArr] = useState<Jisa[]>([]);
  // 페이지네이션
  const buttonPerPage = 10; // 보여줄 페이지네이션 버튼 수
  const [page, setPage] = useState(searchObj.page || 1); // 현재 페이지
  const [limit] = useState(10); // 보여줄 게시물 개수
  const [totalCount, setTotalCount] = useState(-1);
  const numPages = Math.ceil(totalCount / limit); // 총 페이지 수
  const [startButtonNum, setStartButtonNum] = useState(1); // 버튼 시작 숫자

  // 페이지네이션 버튼 클릭 시
  const isClickButton = (str:string) => {
    if (str === 'prev') handlePrevPage();
    else handleNextPage();
  };

  // 이전페이지 이동(buttonPerPage만큼 -)
  const handlePrevPage = () => {
    const prevPage = Math.max(startButtonNum - buttonPerPage, 1);
    setStartButtonNum(prevPage);
    setPage(prevPage);
  };

  // 다음페이지 이동(buttonPerPage만큼 +)
  const handleNextPage = () => {
    const nextPage = Math.min(startButtonNum + buttonPerPage, numPages);
    setStartButtonNum(nextPage);
    setPage(nextPage);
  };

  const handleKeyDown = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') searchHandle();
  }

  const searchHandle = () => {
    page === 1 ? getJisa(page, limit) : setPage(1);
  }

  const getJisa = async (page: number, limit: number) => {
    const { type, value} = searchObj;
    const param: Record<string, string> = { [type]: value };
    const jisaRes = await getJisaAll(page, limit, param);
    if (jisaRes.code === 200) {
      setJisaArr(jisaRes.data);
      setTotalCount(jisaRes.total_count);
    }
    setSearchParams({ type, value, page : String(page) });
  };
  
  // 검색 type 변경
  const handleSearchType = (type: string) => {
    setSearchObj(prev => ({...prev, type, value: "" }));
  };
  // 검색 value 변경
  const handleSearchValue = (value: string) => {
    setSearchObj(prev => ({...prev, value}));
  };
  
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      const hasParams = searchParams.toString() !== "";
      if (!hasParams) return; // ❌ 파라미터 없으면 첫 렌더 스킵
    }
    getJisa(page, limit); // ✅ 이후에는 무조건 실행
  }, [page, limit]);
  return (
    <>
      <FilterContentContainer>
        <div className='flex-row'>
          <label>검색</label>
          <div>
            <select name="search_type" onChange={(e) => handleSearchType(e.target.value)} value={searchObj.type} >
              <option value="bonbu_name">본부명</option>
              <option value="jisa_name">지사명</option>
            </select>
          </div>
          <div>
            <input type="text" name="search_value" onChange={(e) => handleSearchValue(e.target.value)} value={searchObj.value} placeholder="검색 내용 입력" onKeyUp={handleKeyDown} />
          </div>
        </div>
        <PrimaryButton type="button" onClick={searchHandle}>조회</PrimaryButton>
        <div className='flex-row btn-wrap'>
          <PrimaryButton type="button" onClick={() => navigate('process')}>등록</PrimaryButton>
        </div>
      </FilterContentContainer>
      <div>
        검색 결과: <span style={{ fontWeight: "600" }}>{totalCount < 0 ? 0 : totalCount}</span>건
      </div>
      <CommonTableWrap>
        <CommonTable>
          <thead>
            <tr>
              <th className='w-5'>No</th>
              <th className='w-10'>본부명</th>
              <th className='w-10'>지사명</th>
              <th className='w-10'>지사 코드</th>
              <th className='w-15'>비고</th>
              <th className='w-10'>생성 일자</th>
            </tr>
          </thead>
          <tbody>
              {totalCount === 0 ?
                <tr>
                  <td colSpan={7}>검색결과가 없습니다.</td>
                </tr>
                :
                jisaArr.map((jisa, idx) => 
                  <tr key={`jisa_${idx}`} onClick={() => navigate(`process/${jisa.idx}`)}>
                    <td>{(page - 1) * 10 + idx + 1}</td>
                    <td>{jisa.bonbu_name}</td>
                    <td>{jisa.jisa_name}</td>
                    <td>{jisa.jisa_code}</td>
                    <td className='ellipsis-text'>{jisa.bigo}</td>
                    <td>{formattedDateTime(jisa.create_date)}</td>
                  </tr>
                )
              }
          </tbody>
        </CommonTable>
      </CommonTableWrap>
      <Pagenation
        totalCount={totalCount}
        total={numPages}
        limit={limit}
        page={page}
        setPage={setPage}
        startButtonNum={startButtonNum}
        setClickButton={isClickButton}
      />
    </>
  );
}

export default JisaList;